import { Config } from "@/api/AppApi/config";
import ApiService from "@/api/baseApi/api-service";
import {
  IUploadBlobParams,
  IUploadFileParams,
  IUploadImageRes,
} from "./interfaces/IUpload";

const URLs = {
  imageUpload: "/image/upload",
  fileUpload: "/file/upload",
};
class ApiUpload extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  imageUpload = (body: IUploadFileParams): Promise<IUploadImageRes> => {
    const formData = new FormData();
    formData.append("file", body.file);
    return this.post(URLs.imageUpload, formData);
  };
  fileUpload = (body: IUploadFileParams): Promise<IUploadImageRes> => {
    const formData = new FormData();
    formData.append("file", body.file);
    return this.post(URLs.fileUpload, formData);
  };
  audioUpload = (body: IUploadBlobParams): Promise<IUploadImageRes> => {
    const formData = new FormData();
    formData.append("file", body.blob, "_.mp3");
    return this.post(URLs.fileUpload, formData);
  };
}
export default ApiUpload;
